import React from "react";
import "../../styles/Css/Testimonials.css";

const TestimonialSection = () => {

    const testimonials = [
        {
            rating: 5,
            text: "Deal to Close AI has been an absolute lifesaver. My transaction management is now incredibly efficient. I can focus on what I do best - selling homes!",
            author: 'Sarah Mitchell',
            role: 'Real Estate Broker, REALTOR®, PMN',
            avatar: '/images/avatar-1.png'
        },
        {
            rating: 5,
            text: "Finally, technology that understands real estate transactions! Deal to Close AI has streamlined my entire process. Simply amazing.",
            author: 'Marcus Johnson',
            role: 'Luxury Home Specialist',
            avatar: '/images/avatar-2.png'
        },
        {
            rating: 5,
            text: "As a busy agent, I was skeptical of AI tools. But Deal to Close AI proved me wrong. It has helped me close more deals while spending less time on admin.",
            author: 'Jennifer Rodriguez',
            role: 'Top Producer, RE/MAX Elite',
            avatar: '/images/avatar-3.png'
        }
    ];

    return (
        <section className="testimonials section">
            <div className="container">
                <h2 className="section-title">Loved by Real Estate Professionals</h2>
                <p className="section-subtitle">
                    See what agents are saying about Deal to Close AI
                </p>
                <div className="testimonials__grid">
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="testimonial-card">
                            <div className="testimonial-card__rating" style={{ cursor: "pointer" }}>
                                {[...Array(testimonial.rating)].map((_, i) => (
                                    <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                ))}
                            </div>
                            <p className="testimonial-card__text">"{testimonial.text}"</p>
                            <div className="testimonial-card__author">
                                <div className="testimonial-card__avatar">
                                    <span>{testimonial.author.charAt(0)}</span>
                                </div>
                                <div className="testimonial-card__info">
                                    <span className="testimonial-card__name">{testimonial.author}</span>
                                    <span className="testimonial-card__role">{testimonial.role}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>

    )
}

export default TestimonialSection;